<script>
  import "firebase/auth";
  import "firebase/firestore";

  import { getContext } from "svelte";
  import { Collection } from "sveltefire";

  import { userStore, userOrganizationID } from "../stores";
  import PageTitle from "../components/PageTitle.svelte";
  import InvoiceRow from "../components/InvoiceRow.svelte";

  const firebase = getContext("firebase").getFirebase();
  const auth = firebase.auth();

  let _isEmailVerified = false;
  let _hasEmailBeenSent = false;

  let _firstName = "";
  let _lastName = "";

  let errorMessage = "";
  let newPassword1 = "";
  let newPassword2 = "";
  $: disabled = !newPassword1 || newPassword1 !== newPassword2;

  userStore.subscribe((a) => {
    if (!a) {
      return;
    }
    _isEmailVerified = a.emailVerified;
    _firstName = a.firstName;
    _lastName = a.lastName;
  });

  function onVerifyEmail() {
    const user = auth.currentUser;
    if (!user) {
      return;
    }

    user.sendEmailVerification().then(function () {
      _hasEmailBeenSent = true;
    });
  }

  function onChangePassword() {
    const user = auth.currentUser;
    if (!user) {
      return;
    }

    user
      .updatePassword(newPassword1)
      .then(function () {
        errorMessage = "";
        newPassword1 = "";
        newPassword2 = "";
      })
      .catch(function (error) {
        errorMessage = error.message;
      });
  }

  function logout() {
    auth.signOut().catch(function (err) {
      console.log("Logout error", err);
    });
  }

  let query = (ref) =>
    ref
      .where("organization", "==", $userOrganizationID)
      .orderBy(firebase.firestore.FieldPath.documentId());
</script>

<PageTitle text={"Settings"} />

<div class="card">
  <h4>{`${_firstName} ${_lastName}`}</h4>
  <hr />
  <div class="verify">
    {#if _isEmailVerified}
      <p class="verify-text">Email Verified</p>
      <i class="fas fa-check-circle" />
    {:else if _hasEmailBeenSent}
      <p>Verification Email Sent!</p>
    {:else}
      <p class="verify-text">Verify Email</p>
      <input type="button" value="Verify" on:click={onVerifyEmail} />
    {/if}
  </div>
  <hr />
  <p>Change Password</p>
  <form on:submit|preventDefault={onChangePassword}>
    <input
      bind:value={newPassword1}
      type="password"
      placeholder="New Password"
    />
    <input
      bind:value={newPassword2}
      type="password"
      placeholder="Repeat Password"
    />
    <input type="submit" value="Change Password" {disabled} />
  </form>
  {#if errorMessage}
    <div class="form-error-message">
      <span>{errorMessage}</span>
    </div>
  {/if}
  <hr />
  {#if $userOrganizationID != null}
    <p>Invoices</p>
    <Collection path={"invoices"} {query} let:data={invoices}>
      {#each invoices as invoice}
        <InvoiceRow {invoice} />
      {/each}
    </Collection>
    <hr />
  {/if}
  <div class="logout">
    <input type="button" value="Logout" on:click={logout} />
  </div>
</div>

<style>
  .card {
    max-width: 500px;
    margin: auto;
    text-align: left;
    color: var(--off-black);
    background-color: var(--white);
    padding: 20px;
    border-radius: 15px;
    box-shadow: var(--box-shadow);
  }

  form {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  input {
    margin: 5px 0px;
  }

  input[type="submit"]:disabled {
    background-color: var(--grey);
  }

  .verify {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
  }

  .verify-text {
    margin-right: 10px;
  }

  .fa-check-circle {
    color: var(--positive);
  }

  .logout {
    text-align: center;
  }
</style>
